import * as React from 'react';
import { Sparkles } from 'lucide-react';
import { DMText } from '../Primitives';

type DMQualityHintProps = {
  className?: string;
  message?: string;
};

const defaultMessage =
  'Low quality image? Don\u0027t worry, Just Upload and get HD Images Instantly!!';

export const DMQualityHint = ({
  className = '',
  message = defaultMessage,
}: DMQualityHintProps) => (
  <DMText
    className={`flex items-center justify-center gap-[0.4vw] text-[1.2vh] font-semibold text-primary-main ${className}`}
  >
    <Sparkles className="h-[1.6vh] w-[1.6vh] shrink-0" strokeWidth={2} />
    <DMText as="span">{message}</DMText>
  </DMText>
);
